import React from 'react'

export const ProductDetailAsync = React.lazy(() => import('./product-detail'))
